import { useEffect } from 'react';

import { usePageExport } from './chart-menu/PageExportProvider';

type GaugeExportMetaProps = {
  chartId: string;
  enabled: boolean;
  gaugeMainText: string;
  gaugeSubText: string;
  gaugeUnit?: string;
  gaugeValue: number;
  gaugeColors?: string[];
  gaugeMinLabel?: string;
  gaugeMaxLabel?: string;
};

export const GaugeExportMeta = ({
  chartId,
  enabled,
  gaugeMainText,
  gaugeSubText,
  gaugeUnit,
  gaugeValue,
  gaugeColors,
  gaugeMinLabel,
  gaugeMaxLabel,
}: GaugeExportMetaProps) => {
  const { updateChartExportInfo, clearChartExportInfo } = usePageExport();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    updateChartExportInfo(chartId, {
      gaugeMainText,
      gaugeSubText,
      gaugeUnit,
      gaugeValue,
      gaugeColors,
      gaugeMinLabel,
      gaugeMaxLabel,
    });
    const removedFields = (
      ['gaugeUnit', 'gaugeColors', 'gaugeMinLabel', 'gaugeMaxLabel'] as const
    ).filter(
      (field) =>
        ({ gaugeUnit, gaugeColors, gaugeMinLabel, gaugeMaxLabel })[field] ===
        undefined
    );
    if (removedFields.length > 0) {
      clearChartExportInfo(chartId, removedFields);
    }
  }, [
    chartId,
    enabled,
    gaugeMainText,
    gaugeSubText,
    gaugeUnit,
    gaugeValue,
    gaugeColors,
    gaugeMinLabel,
    gaugeMaxLabel,
    updateChartExportInfo,
    clearChartExportInfo,
  ]);

  return null;
};
